import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import app from './app';
import getters from './getters';
import router from './router';
import operationsMg from './operationsMg.js';
import projectMg from './projectMg';
import uploaderLocal from "./uploaderLocal";
import perFile from './perFile';
import XtDesign from './XtDesign';
import monge from './monge';
import enterprise from './enterprise';
import uploaderAnnotation from './question';
import appperFile from './appperFile';
import prjNotice from './prjNotice';
import sysNotice from './sysNotice';
import sheetSet from './sheetSet';
import commonH5 from "./commonH5";
import centralFileBackup from './centralFileBackup';
import globalParams from '@/CommonDP/utils/globalParams';

Vue.use(Vuex);

let storeConfig = {
  modules: {
    app,
    user,
    router,
    operationsMg,
    projectMg,
    uploaderLocal,
    perFile,
    XtDesign,
    monge,
    enterprise,
    uploaderAnnotation,
    appperFile,
    prjNotice,
    sysNotice,
    sheetSet,
    centralFileBackup,
    commonH5
  },
  getters
};

// 支持扩展状态存储
const storeCustomizeFunc = globalParams.get("fx.storeCustomizeFunc");
if (storeCustomizeFunc) {
  storeConfig = storeCustomizeFunc(storeConfig) || storeConfig;
}

const store = new Vuex.Store(storeConfig);
export default store;
